// src/components/dashboard/WorkforceCard.js
// Dashboard card — active employee count + department breakdown chart.
// Visibility gated by `emp:view` via src/config/dashboardCards.js.

export const WorkforceCard = ({
  isLoading,
  activeEmployees,
  departmentBreakdown,
  donutGradient,
  navigate,
  company,
}) => (
  <div className="dashboard-card">
    <div className="dashboard-card__header">
      <span className="dashboard-card__title">Workforce</span>
    </div>
    <div className="workforce__hero">
      <div className="workforce__count">
        {isLoading ? "..." : activeEmployees.length}
      </div>
      <div className="workforce__label">Active Employees</div>
    </div>
    {activeEmployees.length > 0 && (
      <>
        <div className="workforce__chart">
          <div
            className="donut-chart"
            style={{ background: donutGradient }}
          ></div>
        </div>
        <div className="workforce__legend">
          {Object.entries(departmentBreakdown)
            .slice(0, 4)
            .map(([dept, data]) => (
              <div key={dept} className="legend-item">
                <span
                  className="legend-dot"
                  style={{ backgroundColor: data.color }}
                ></span>
                {dept}: {data.count} ({data.percentage}%)
              </div>
            ))}
        </div>
      </>
    )}
    <div className="dashboard-card__footer">
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          navigate(`/company/${company.slug}/employees`);
        }}
        className="dashboard-card__link"
      >
        View all employees →
      </a>
    </div>
  </div>
);